module.exports = {
    API_TITLE:"乡村美术教师网课系统", //项目名称
    testdomainName:"https://api.xuqinsong-art.org.cn/", //测试域名
    domainName:"https://api.xuqinsong-art.org.cn/", //正式域名
    interfacePrefix:"", //接口前缀
    port:8032, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
    
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 7